import { Dictionary } from '@/models/utils/dictionary';
import { defineStore } from 'pinia';
import { getCurrentInstance } from 'vue';
import { ref } from 'vue';

export const useCommonStore = defineStore({
    id: 'common',
    state: () => ({
        language: ref('ja'),
        from: '', // 遷移元画面。
        reservePageBack: false, // 前画面からの戻るフラグ。
        API_URL: '', // APIのURL。
        isSsoLoggedin: false, // SSOログインを行った場合。
    }),
    getters: {
        getLanguage() {
            return this.language;
        },
        getConvertDictionary: () => (type, key, lang) => {
            const dictionary = Dictionary[type][key];
            return dictionary ? dictionary[lang] || '' : '';
        },
        getDictionary: () => (type) => {
            return Dictionary[type];
        },
        /**
         * 格納されている画面遷移元情報を返却する。
         * @param なし
         * @returns {string} from 画面遷移元の情報。
         */
        getFrom() {
            return this.from;
        },
    },
    actions: {
        resetAllStorage() {
            localStorage.clear();
            sessionStorage.clear();
        },
        resetSessionStorage() {
            sessionStorage.clear();
        },
        resetLocalStorage() {
            localStorage.clear();
        },
        /**
         * 画面遷移元の情報を設定する。
         * 例：本来はホーム画面から一覧画面を経由して詳細画面を表示する遷移が、ホーム画面から直に詳細画面を表示したい場合は、「home」などホーム画面からの遷移であることを示す文字列を入力する。
         * @param {string} from
         * @returns なし
         */
        setFrom(from) {
            this.from = from;
        },
        setLanguage(value) {
            this.language = value;
        },
        reset() {
            this.from = '';
            this.reservePageBack = false;
            this.API_URL = '';
        },
        resetAll() {
            this.from = '';
            this.reservePageBack = false;
            this.API_URL = '';
            this.isSsoLoggedin = false; // SSOログインを行った場合。
        },
        /**
         * APIのドメイン部分を取得
         */
        async getDomain() {
            const app = getCurrentInstance();
            this.API_URL = app.appContext.config.globalProperties.$constProperties.BASE_API_URL_S;
        },
    },
    persist: {
        // ローカルストレージに保存する。
        storage: localStorage,
    },
});
